import styled from "styled-components";
import { TableCell, TableRow } from "@mui/material";

const Cell = styled(TableCell)({
  height: 50,
  padding: 0,
  borderRight: "2px solid white",
  borderBottom: 0,
  textAlign: "center",
  alignItems: "center",
});

const HeaderCell = styled(TableCell)({
  height: 50,
  padding: 0,
  borderRight: "2px solid white",
  borderBottom: 0,
  textAlign: "center",
  alignItems: "center",
});

const Row = styled(TableRow)({
  padding: 0,
  borderBottom: "2px solid white",
});

const AllocationRow = styled(TableRow)({
  padding: 0,
  borderBottom: "2px solid #cdcdcd",
});

const AllocationRowClosed = styled(TableRow)({
  padding: 0,
  borderBottom: "2px solid #cdcdcd",
  color: "#757575",
  backgroundColor: "#eee",
});

const AllocationCellText = styled(TableCell)({
  padding: 2,
});

const AllocationHeaderCellText = styled(TableCell)({
  fontWeight: 700,
  padding: 2,
});

const AllocationCellNumber = styled(TableCell)({
  textAlign: "center",
  padding: 2,
});

const AllocationHeaderCellNumber = styled(TableCell)({
  textAlign: "center",
  fontWeight: 700,
  padding: 2,
});

export {
  AllocationCellText,
  AllocationHeaderCellText,
  AllocationCellNumber,
  AllocationHeaderCellNumber,
  AllocationRow,
  AllocationRowClosed,
  Cell,
  HeaderCell,
  Row,
};
